import localeEn from '@/app/pharmacy/locales/en'
import localeAr from '@/app/pharmacy/locales/ar'
import { showPopupNotification } from '@/app/shared/grid-functionality/grid-functionality.js';
import { getAttachmentSaveResult } from '@/app/pharmacy/shared/pharmacy-enums.js';
import { visitService } from '@/app/pharmacy/shared/services/visit-service';
import { EventBus } from '@/app/shared/services/event-bus.js';

export default {

    data() {
        return {
            isAssigned: false,
            hideNotification: 5000,
            suffix: 'delete-confirmPopup',
            visitId: null,
            attachmentID: null,
            confirmdata: [
                {
                    confirmText: '',
                    confirmBtnBtnText: '',
                    cancelBtnText: '',
                    headerTitle: '',
                    messageText: '',
                    poptype: '',
                    itemName: '',
                    qmark: '',
                    popupclass: ''
                }
            ],
        }
    },
    props: [
        'msuffix'
    ],
    methods: {
        showPopupNotification,
        cancel() {
            EventBus.$emit('ReloadGrid', '');
            this._bv__modal.hide('InAssigndeleteConfirmPopup-modal-scoped');
        },


        confirmAction() {
             
            visitService.InAssignPatientAttachmentToVisit(this.attachmentID, this.visitId, response => {
                if (response) {
                    this.$parent.initAttachmentModal()
                    switch (response.data) {
                        case parseInt(getAttachmentSaveResult().Success):

                            this.showPopupNotification(`${this.$i18n.t('Common.Success')}`, `${this.$i18n.t('Pharmacy.AttachmentDeleted')}`, `success`);
                            this.cancel();
                            break;


                        case parseInt(getAttachmentSaveResult().Failure):
                            this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('Pharmacy.ERROROccurred')}`, `error`);
                            this.cancel();
                            break;

                    }
                }
                else {
                    this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('Pharmacy.ERROROccurred')}`, `error`);
                    this.cancel();
                    this._bv__modal.hide('attachment');
                }
            });


            
        },


    },

    beforeDestroy() {
        EventBus.$off("InAssignParameters");

 
    },

    mounted() {
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();

        EventBus.$on('InAssignParameters', (data) => {
            this.visitId = data.VisitID;
            this.attachmentID = data.AttachmentID;


        });

    },
    computed: {


    },
    components: {
        showPopupNotification
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },
}
